/**
 * projectRoute — para onde "abrir projeto" leva, pelo status do projeto.
 *
 * Mesma regra que a tabela do Dashboard sempre usou (agora compartilhada com a
 * busca global): passa o execution id (= temporal_workflow_id do projeto) às telas
 * de execução, que o leem de ?execution=; projeto em jornada abre a Gestão do
 * Projeto DESTE projeto (?project=).
 */
export function projectRoute(p) {
  if (!p) return '/dashboard';
  const q = p.temporal_workflow_id ? `?execution=${p.temporal_workflow_id}` : '';
  if (p.status === 'running') return `/execution/liveboard${q}`;
  if (p.status === 'gate-waiting') return `/execution/liveboard${q}`;
  if (p.status === 'completed') return `/execution/output${q}`;
  if (p.status === 'failed') return `/execution/failure${q}`;
  return `/project?project=${p.id}`;
}
